module.exports = __webpack_public_path__ + "media/images/basket-delete-f5b5f0be.svg";